import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';

import TextField from '../../../forms/TextField';

export default function Variables() {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: 'variables',
    control,
  });

  // Note: normally by using an field array, it would be returning an array of objects, like:
  // [ { value: 'asdf', }, { value: 'fdsa' } ]
  // But I was able to trick it to return:
  // [ 'asdf', 'fdsa' ]
  // by using Controller and naming the field `variables.${index}`
  // and on the TextField, I named it `variables.${index}.value`}
  // When loading values into it, it also expects:
  // [ { value: 'asdf', }, { value: 'fdsa' } ]
  // So we perform a type check to see what to do.
  // typeof(field.value) === 'string' ? field.value : field.value.value
  return (
    <Stack spacing={2}>
      <Typography variant="h6">Variables</Typography>
      {fields.map((unused, index) => (
        <Stack mb={1} key={unused.id}>
          <Controller
            name={`variables.${index}`}
            control={control}
            render={() => (
              <TextField
                label={`CRV${index + 1} =`}
                name={`variables.${index}`}
                normalizeInput={(value) => (typeof value === 'string' ? value : value.value) || ''}
              />
            )}
          />
        </Stack>
      ))}
      <Stack direction="row" spacing={2}>
        {fields.length < 5 && <Button onClick={() => append({ value: '' })}>Add Variable</Button>}
        {fields.length > 0 && <Button onClick={() => remove(fields.length - 1)}>Delete Variable</Button>}
      </Stack>
    </Stack>
  );
}
